import React, { useCallback } from "react";
import { DurationPickerBase } from "./DurationPicker";

const btnProps = {
  size: "middle",
  style: {},
  block: true,
};

export default function DurationPickerField({ value, onChange, allowFutureDates }) {
  const _onChange = useCallback(
    ({ selectedDuration, foundOn }) => {
      onChange(selectedDuration ? [selectedDuration] : foundOn);
    },
    [onChange]
  );
  return (
    <DurationPickerBase onChange={_onChange} value={value} btnProps={btnProps} allowFutureDates={allowFutureDates}/>
  );
}
